<template>
    <div id="app">
        <app-main-menu v-if="['Main'].indexOf($route.name) > -1"></app-main-menu>
        <app-menu v-if="[
            'Suitecrm',
            'Waterman3',
            'Importsubst',
            'App321',
            'Mrpq321',
            'Price',
            'License',
            'Vacancies',
            'Contacts',
            'Waterman20',
            'WatermanPromo',
            'InterviewWaterman20',
            'NotFound'
        ].indexOf($route.name) > -1">
        </app-menu>

        <router-view/>

        <app-footer/>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'vue-popperjs/dist/css/vue-popper.css'
import MainMenu from '@/components/parts/MainMenu'
import Menu from '@/components/parts/Menu'
import Footer from '@/components/parts/Footer'
import Popper from 'vue-popperjs'

export default {
    name: 'App',
    components: {
        AppMainMenu : MainMenu,
        AppMenu : Menu,
        AppFooter: Footer,
        popper: Popper
    }
}
</script>

<style scoped>
    .h1, h1 {
        font-size: 2.3rem;
    }
    body {
        font-family: Roboto;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue